import { ArrowRight, Upload } from "lucide-react";
import { Btn, money } from "../../comptabilite/_shared";

function Kpi({ label, value, sub, tone = "slate", testId }) {
  const tones = { slate: "bg-white border-slate-200 text-slate-900", teal: "bg-teal-50 border-teal-200 text-teal-900", amber: "bg-amber-50 border-amber-200 text-amber-900", rose: "bg-rose-50 border-rose-200 text-rose-900", emerald: "bg-emerald-50 border-emerald-200 text-emerald-900" };
  return (
    <div className={`border rounded-xl p-3 ${tones[tone]}`} data-testid={testId}>
      <div className="text-[10px] uppercase tracking-wider font-semibold opacity-70">{label}</div>
      <div className="text-base sm:text-lg font-bold tabular-nums mt-0.5 font-mono">{value}</div>
      {sub && <div className="text-[10px] opacity-70 mt-0.5 truncate">{sub}</div>}
    </div>
  );
}

export default function BankSummary({ summary, goTab, onImport }) {
  if (!summary) return null;
  const s = summary;
  if (!s.statements) {
    return (
      <div className="bg-teal-50 border border-teal-200 rounded-xl p-4 flex items-center gap-3 flex-wrap" data-testid="bank-summary-empty">
        <div className="flex-1 text-sm text-teal-900">
          <div className="font-semibold">Aucun relevé importé pour {s.account.number} — {s.account.name}</div>
          <div className="text-xs text-teal-800/80">Exportez le relevé depuis votre banque (OFX, QFX ou CSV — AccèsD Desjardins reconnu) puis importez-le ici. Solde au grand livre : <strong className="font-mono">{money(s.gl_balance)}</strong></div>
        </div>
        <Btn tone="sky" icon={Upload} onClick={onImport} testId="bank-summary-import-btn">Importer un relevé</Btn>
      </div>
    );
  }
  const ok = s.difference !== null && Math.abs(s.difference) < 0.005;
  return (
    <div className="space-y-2" data-testid="bank-summary">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        <Kpi label="Solde du relevé" value={s.bank_balance === null ? "—" : money(s.bank_balance)} sub={s.bank_balance_date ? `au ${s.bank_balance_date}` : "non fourni par le fichier"} tone="teal" testId="bank-kpi-bank" />
        <Kpi label="Solde au grand livre" value={money(s.gl_balance)} sub={`au ${s.as_of}`} testId="bank-kpi-gl" />
        <Kpi label="À concilier (banque)" value={s.unmatched_bank.count} sub={`${money(s.unmatched_bank.total)} non comptabilisés`} tone={s.unmatched_bank.count ? "amber" : "emerald"} testId="bank-kpi-unmatched" />
        <Kpi label="En circulation (GL)" value={s.outstanding_gl.count} sub={s.before_start?.count ? `${money(s.outstanding_gl.total)} · ${s.before_start.count} avant le ${s.start_date} ignorée(s)` : `${money(s.outstanding_gl.total)} sans ligne au relevé`} tone={s.outstanding_gl.count ? "amber" : "emerald"} testId="bank-kpi-outstanding" />
        <Kpi label="GL en attente" value={s.pending_gl.count} sub={`${money(s.pending_gl.total)} à reporter au GL`} tone={s.pending_gl.count ? "amber" : "slate"} testId="bank-kpi-pending" />
        <Kpi label="Écart" value={s.difference === null ? "—" : money(s.difference)} sub={s.difference === null ? "solde du relevé inconnu" : ok ? "Concilié ✓" : "après ajustements"} tone={s.difference === null ? "slate" : ok ? "emerald" : "rose"} testId="bank-kpi-difference" />
      </div>
      {s.pending_gl.count > 0 && (
        <button onClick={() => goTab("grand-livre", "journal")} className="text-xs text-teal-700 hover:underline inline-flex items-center gap-1" data-testid="bank-goto-gl">
          {s.pending_gl.count} écriture(s) conciliée(s) attendent le report au grand livre <ArrowRight className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
